/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import _t from 'i18n!nls/staff-management';

import AddStaffButton from './AddStaffButton';

const styles = {
  paddedBox: css`
    align-items: center;
    display: flex;
    justify-content: center;
    padding: 1rem;
  `,
};
const NO_STAFF_E2E_NAME = 'staff-management-no-staff';

/**
 * Component to show when there are zero staff memberships.
 */
export const NoStaff = () => {
  return (
    <div className="rc-NoStaff" data-e2e={NO_STAFF_E2E_NAME}>
      <div css={styles.paddedBox}>
        <AddStaffButton />
      </div>
      <div css={styles.paddedBox}>
        <span>{_t(`There are no associated staff. Click on 'Add Staff' to add staff members.`)}</span>
      </div>
    </div>
  );
};

export default NoStaff;
